/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import i18n from '@i18next/i18n';

import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { RadarChartConfigHelper } from './radar-chart-config-helper';
import { AreaChartConfigHelper } from './area-chart-config-helper';
import { BarChartConfigHelper } from './bar-chart-config-helper';
import { LineChartConfigHelper } from './line-chart-config-helper';
import { PieChartConfigHelper } from './pie-chart-config-helper';
import { DoughnutChartConfigHelper } from './doughnut-chart-config-helper';
import { ScatterChartConfigHelper } from './scatter-chart-config-helper';
import { BubbleChartConfigHelper } from './bubble-chart-config-helper';
import { StockChartConfigHelper } from './stock-chart-config-helper';
import { OfPieChartConfigHelper } from './of-pie-chart-config-helper';
import { ComboChartConfigHelper } from './combo-chart-config-helper';

import type { BaseChartConfigHelper } from './base-chart-config-helper';
import type { ISubChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import type {
    ChartLayoutInfo,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/interface/chart-component.interface';

export class ChartConfigFactory {
    static getConfigHelperWithModel(chartModel: IChartModel, layout: ChartLayoutInfo):
        BaseChartConfigHelper | ComboChartConfigHelper |undefined {
        const { charts } = chartModel.plotArea;

        if (charts.length > 1) {
            return this.createComboChartConfigHelper(charts, layout);
        }

        return this.createConfigHelperByType(charts?.[0], layout);
    }

    // eslint-disable-next-line complexity
    static getConfigHelper(subChartModel: ISubChartModel, layout: ChartLayoutInfo): BaseChartConfigHelper | undefined {
        let configHelper: BaseChartConfigHelper | undefined;

        if (!subChartModel) {
            console.error('[ChartConfigFactory]', i18n.t('subChart为空'));
            return;
        }

        const { type } = subChartModel;
        switch (type) {
            case SubChartType.AreaChart:
                configHelper = new AreaChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.BarChart:
                configHelper = new BarChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.LineChart:
                configHelper = new LineChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.RadarChart:
                configHelper = new RadarChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.PieChart:
                configHelper = new PieChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.DoughnutChart:
                configHelper = new DoughnutChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.ScatterChart:
                configHelper = new ScatterChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.BubbleChart:
                configHelper = new BubbleChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.StockChart:
                configHelper = new StockChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
            case SubChartType.OfPieChart:
                configHelper = new OfPieChartConfigHelper(subChartModel.getContext(), layout).init();
                break;
        }

        return configHelper;
    }

    static createConfigHelperByType(subChart: ISubChartModel, layout: ChartLayoutInfo):
    BaseChartConfigHelper | undefined {
        const configHelper = this.getConfigHelper(subChart, layout);
        if (!configHelper) {
            console.warn(i18n.t('不支持的图表类型'));
            return;
        }

        return configHelper;
    }

    static createComboChartConfigHelper(charts: ISubChartModel[], layout: ChartLayoutInfo):
    ComboChartConfigHelper {
        // 传入 getConfigHelper 避免循环引用
        const configHelper = new ComboChartConfigHelper(charts, layout, ChartConfigFactory.getConfigHelper);
        return configHelper;
    }
}
